<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/products">Products</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}`">{{ this.$store.state.product.name }}</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}/things`">Smart things</router-link></li>
        <li><router-link v-bind:to="`/products/${this.$route.params.product_id}/things/${this.$route.params.thing_id}`">{{ this.$store.state.thing.name || 'No name' }}</router-link></li>
        <li><a href="#" aria-current="page">Edit smart thing name</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">Smart thing name</label>
          <div class="control">
            <input
              name="name"
              type="text"
              placeholder="Smart thing name"
              v-model="fields.name"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('name') }"
              v-validate="'required'"
              data-vv-as="Smart thing name">
          </div>
          <span v-show="veeErrors.has('name')" class="help is-danger">{{ veeErrors.first('name') }}</span>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Submit</button>
          </div>
          <div class="control">
            <router-link v-bind:to="`/products/${this.$route.params.product_id}/things/${this.$route.params.thing_id}`" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fields: {
          name: ''
        },
        isLoading: false
      }
    },

    methods: {
      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.$store.dispatch('updateThing', {
            thingId: this.$route.params.thing_id,
            params: this.fields
          })
            .then(() => {
              this.$router.push(`/products/${this.$route.params.product_id}/things/${this.$route.params.thing_id}`)
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      }
    },

    created () {
      this.$store.dispatch('getProduct', {
        productId: this.$route.params.product_id
      })

      this.$store.dispatch('getThing', {
        thingId: this.$route.params.thing_id
      })
        .then(() => {
          this.fields = {
            name: this.$store.state.thing.name
          }
        })
    }
  }
</script>



// WEBPACK FOOTER //
// ThingForm.vue?da2a4618